import { Stack } from '@mui/material';
import styled from 'styled-components';

import { TOverLoaderStyledProps } from '@/shared/components/ui/overlay-loader/overlay-loader.types';

export const LoaderOverlay = styled(Stack)<TOverLoaderStyledProps>`
  && {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.palette.background.loaderOverlay};
    z-index: 1000;
    border-radius: ${({ theme, $squareTop }) =>
      $squareTop
        ? `0 0 ${theme.shape.cardRadius} ${theme.shape.cardRadius}`
        : theme.shape.cardRadius};
    pointer-events: auto;
  }
`;
